import { HttpClient, HttpErrorResponse, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { IntegrationCompany } from 'sharedGuiSmall/enums';

declare var appPath: string;

declare let handleAngularHttpError: any;

@Injectable({ providedIn: 'root' })
export class RedirectGlobalService {

    constructor(private http: HttpClient) { }
    
    getIntegrationCompanySSO(integrationCompany: IntegrationCompany, getNews?: boolean, state?: string): Promise<string> {
        const headers = new HttpHeaders()
            .set('Content-Type', 'application/x-www-form-urlencoded;charset=UTF-8');

        let params = new HttpParams()
            .set('company', integrationCompany);

        if (getNews != undefined)
            params = params.set("getNews", `${getNews}`)

        if (state != undefined)
            params = params.set("state", `${state}`)

        const body = params.toString();

        const url = `${window.appPath}Auth/GetIntegrationCompanySSO`;

        const response = this.http.post<string>(url, body, { headers: headers });

        return lastValueFrom(response)
            .then((res: string) => { return res; })
            .catch((error: HttpErrorResponse) => {
                console.error('GetIntegrationClientId error', error);

                handleAngularHttpError(error);

                throw error;
            });
    }
    
    async redirectToIntegrator(integrationCompany: IntegrationCompany, getNews?: boolean, state?: string) {

        let urlForSSO = await this.getIntegrationCompanySSO(integrationCompany, getNews, state);

        if (urlForSSO.length && urlForSSO.indexOf("error=sessiontimeout") === -1) {
            location.href = urlForSSO;
        }
    }
}
